import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api } from "@/lib/api";

export default function PreviousLoans() {
  const [loans, setLoans] = useState([]);
  useEffect(() => { api.get("/loans").then((r) => setLoans(r.data.filter((l) => ["closed","rejected"].includes(l.status)))).catch(() => {}); }, []);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">History</div>
          <h1 className="font-display text-3xl mt-2">Previous loans</h1>
        </div>
        <Card className="p-0 overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>ID</TableHead><TableHead>Type</TableHead><TableHead>Amount</TableHead><TableHead>Status</TableHead><TableHead>Closed on</TableHead></TableRow></TableHeader>
            <TableBody>
              {loans.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">No previous loans yet.</TableCell></TableRow>}
              {loans.map((l) => (
                <TableRow key={l.id}>
                  <TableCell className="font-mono text-xs">{l.id.slice(0, 8)}</TableCell>
                  <TableCell className="capitalize">{l.loan_type.replace("_"," ")}</TableCell>
                  <TableCell>₹{Number(l.amount).toLocaleString("en-IN")}</TableCell>
                  <TableCell><span className="text-xs px-2 py-1 rounded-full bg-muted">{l.status}</span></TableCell>
                  <TableCell>{l.decision_at ? new Date(l.decision_at).toLocaleDateString() : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </DashboardLayout>
  );
}
